<template>
    <v-card class="fill-height" fluid>
        <v-toolbar dark color="primary">
            <router-link :to="{ name: 'home' }" tag="v-btn">
                <v-btn icon dark>
                    <v-icon>close</v-icon>
                </v-btn>
            </router-link>
            <v-toolbar-title>Encontrou em algum dos nossos aplicativos?</v-toolbar-title>
        </v-toolbar>

        <v-container class="text-center">
            <h1>Keep Calm!</h1>
            <div class="body-1 mb-4">Estamos prontos para te ajudar, e já pedimos desculpas pelo transtorno.</div>
            <div class="body-1 mb-4">Preencha os dados abaixo que nos esforçaremos para resolver seu problema... Afinal sua satisfação é nosso sucesso.</div>

            <v-form ref="form" v-model="valid">
                <v-text-field v-model="item.name" :rules="nameRules" label="Nome" required />
                <v-text-field v-model="item.email" :rules="emailRules" label="E-mail" required />
                <v-text-field v-model="item.phone" :rules="telRules" label="Telefone" mask="(##) # ####-####" required />
                <v-textarea
                    outlined
                    name="input-7-4"
                    v-model="item.message"
                    label="Mensagem"
                    placeholder="Digite aqui o que você julgar necessário para entendermos seu problema."
                />

                <v-btn color="primary" @click="validate" :loading="processing">Salvar</v-btn>
            </v-form>
        </v-container>
    </v-card>
</template>

<script>
import api from "../helpers/api";
export default {
    name: "Register",
    data() {
        return {
            api,
            processing: false,
            valid: true,
            item: {
                name: "",
                email: "",
                phone: "",
                message: "",
            },
            nameRules: [(v) => !!v || "Nome é obrigatório", (v) => (v && v.length >= 10) || "Nome deve conter pelo menos 10 caracteres"],
            emailRules: [(v) => !!v || "E-mail é obrigatório", (v) => /.{1,}@.{2,}\..{2,}/.test(v) || "E-mail inválido"],
            telRules: [
                (v) => !!v || "Telefone é obrigatório",
                (v) => /^(?:\()?[0-9]{2}(?:\))?\s?[0-9]{1}\s?[0-9]{4}(?:-)?[0-9]{4}$/.test(v) || "Telefone inválido Ex.: (00) 91234-1234",
            ],
        };
    },
    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.processing = true;
                this.api.post(
                    this.$http,
                    "suport",
                    this.item,
                    (res) => {
                        this.$router.replace({ name: "home" });
                        this.$root.$emit("msgSuccess", res.message ? res.message : "Muito obrigado.");
                        this.processing = false;
                    },
                    (err) => {
                        this.$root.$emit("msgError", err.body.message ? err.body.message : "Não foi possível enviar sua solicitação.");
                        this.processing = false;
                    }
                );
            }
        },
    },
    created() {},
};
</script>